import React, { useContext } from "react";
import { VariantContextData } from "../variants/VariantBuilderContext";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";

const ElementSettingsIcon = (props) => {
  const [contextData, builder, setContextData] = useContext(VariantContextData);
  let variant = contextData.objects.variant;
  let element = builder.selected().object;

  return (
    <React.Fragment>
      <VariantBuilderSetting
        object={element}
        setting_name="[options][icon-link]"
        setting_type="text"
        object_type="elements"
        object_id={element.id}
        label="Icon Link"
        placeholder={
          variant.options["icon-link"] ? variant.options["icon-link"] : "https://"
        }
        value={element.options["icon-link"]}
        allow_empty={true}
        show_reset={true}
        condition={element.element_type == "icon"}
      >
        <VariantBuilderSetting
          object={element}
          setting_name="[options][icon-link-new-tab]"
          setting_type="checkbox"
          object_type="elements"
          object_id={element.id}
          label="Open in New Tab"
          value={element.options["icon-link-new-tab"]}
          show_reset={true}
          classNames="!w-[250px]"
        />
      </VariantBuilderSetting>
    </React.Fragment>
  );
};

export default ElementSettingsIcon;


